"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var GlobalDisclaimerLevel_1 = require("./GlobalDisclaimerLevel");
var GlobalDisclaimerStoreValue = /** @class */ (function () {
    function GlobalDisclaimerStoreValue(queryStore, superscript, key, responseContext, appKey, options) {
        var disclaimerType = options.disclaimerType, textQuery = options.textQuery, _a = options.hasHtml, hasHtml = _a === void 0 ? true : _a, order = options.order;
        this.queryStore = queryStore;
        this.disclaimerType = disclaimerType;
        this.appKey = appKey;
        this.key = key;
        this.responseContext = responseContext;
        this.textQuery = textQuery;
        this.hasHtml = hasHtml;
        this.superscript = superscript;
        this.order = order || GlobalDisclaimerStoreValue.maxOrder;
        this.addApp(appKey, options);
    }
    GlobalDisclaimerStoreValue.prototype.addApp = function (key, app) {
        if (!this.appsByKey) {
            this.appsByKey = {};
        }
        this.appsByKey[key] = __assign(__assign({}, app), { appKey: key, level: app.level || GlobalDisclaimerLevel_1.GlobalDisclaimerLevel.page });
        this.updateLevel();
    };
    GlobalDisclaimerStoreValue.prototype.updateLevel = function () {
        var apps = Object.values(this.appsByKey);
        this.level = apps.some(function (app) { return app.level === GlobalDisclaimerLevel_1.GlobalDisclaimerLevel.page; }) ? GlobalDisclaimerLevel_1.GlobalDisclaimerLevel.page : GlobalDisclaimerLevel_1.GlobalDisclaimerLevel.app;
    };
    GlobalDisclaimerStoreValue.prototype.matches = function (level, appKey) {
        return this.level === level && (!appKey || !!this.appsByKey[appKey]);
    };
    Object.defineProperty(GlobalDisclaimerStoreValue.prototype, "text", {
        get: function () {
            return GlobalDisclaimerStoreValue.getText(this.queryStore, this.disclaimerType, this.textQuery, this.responseContext);
        },
        enumerable: true,
        configurable: true
    });
    GlobalDisclaimerStoreValue.maxOrder = 999999;
    GlobalDisclaimerStoreValue.getText = function (queryStore, disclaimerType, initialTextQuery, responseContext) {
        if (queryStore && initialTextQuery) {
            var textQuery = __assign(__assign({}, initialTextQuery), { queryOptionsType: initialTextQuery.queryOptionsType || 'disclaimers' });
            if (textQuery.queryOptionsType === 'disclaimers' && (!textQuery.key || !textQuery.keyQuery) && (!textQuery.options || !textQuery.options.disclaimers || (!textQuery.options.disclaimers.key && !textQuery.options.disclaimers.keyQuery))) {
                if (!textQuery.options) {
                    textQuery.options = {};
                }
                if (!textQuery.options.disclaimers) {
                    textQuery.options.disclaimers = {};
                }
                textQuery.options.disclaimers.key = disclaimerType;
            }
            var overrideExecutionOptions = {};
            if (responseContext) {
                overrideExecutionOptions.responseContext = responseContext;
            }
            return queryStore.query(textQuery, overrideExecutionOptions);
        }
        return '';
    };
    return GlobalDisclaimerStoreValue;
}());
exports.GlobalDisclaimerStoreValue = GlobalDisclaimerStoreValue;
//# sourceMappingURL=GlobalDisclaimerStoreValue.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@kurtosys/ksys-app-template/dist/models/disclaimers/GlobalDisclaimerStoreValue.js
// module id = 886
// module chunks = 1